import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/assets/css/index2024.scss'
import {
  Message,
  MessageBox,
  Row,
  Col,
  Loading,
  Select,
  Option,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  TableColumn,
  Pagination,
  Button,
  Radio,
  RadioGroup,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  Upload,
  Carousel,
  CarouselItem
} from "element-ui"

import { CdelCollection,CdelGuideAppDialog } from '@cdeledu/cdel-acc-exam-pc';
Vue.use(CdelCollection)

Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Option)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Loading.directive)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Image)
Vue.use(Upload)
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(CdelGuideAppDialog)
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
